(function ($) {
  Drupal.behaviors.customerServiceConsultantProfileRowV1 = {
    attach: function (context, settings) {
      $('.cs-consultant-profile-row-v1').each(function () {
        var thisFormatter = $(this);

        // Add gradient background only to this formatter
        thisFormatter.parent().parent().addClass('gradient-bg');

        // Quickview popover
        $('.btn-quickview', thisFormatter).once('template-btn-quickview').on('click', function(e) {
          e.preventDefault();
          $('#quickshop .close').trigger('click');
          var quickview_btn = e.target;
          var prodId = $(this).closest('.product').attr('data-productid');

          if (typeof prodId !== 'undefined') {
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p !== null ? p.PRODUCT_ID === prodId : false;
            })[0];
          }
          var $qs = site.quickshop.render({ productData: product });
          var select_type = $('.shades', $qs).length === 0 ?
            $('.skin-type.hidden', $qs).length === 0 ? 'skin_type' : 'size'
            : 'shade';

          $('.select_type', $qs).html($('span[data-localtrans="' + select_type + '"]', $qs).html()).removeClass('hidden');
          $qs.css('display', 'block').find('.close').hide();

          // wait for review to come in so content stays centered...
          $(document).on('qs.review', function (e) {
            generic.overlay.launch({
              content: $qs,
              center: true,
              includeBackground: true,
              hideOnClickOutside: true,
              includeCloseLink: true
            });
          });
        });
      });
    }
  };
})(jQuery);
